import { enableMapSet } from 'immer';
import {
  AnyAction,
  Reducer,
  Store,
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
} from 'redux';
import thunk from 'redux-thunk';
import { DesignerParams } from '@/types';
import { basketReducer, getInitialBasketState } from '@/redux/basket/reducer';
import { coreReducer, getInitialCoreState } from '@/redux/core/reducer';
import { designsReducer, getInitialDesignState } from '@/redux/designs/reducer';
import { discountsReducer } from '@/redux/discounts/reducer';
import { draftDispatch } from '@/redux/draft/draftDispatch';
import { draftReducer } from '@/redux/draft/reducer';
import { masksReducer } from '@/redux/masks/reducer';
import { reduxActionLogMiddleware } from '@/redux/middleware/raygun';
import { modalReducer } from '@/redux/modal/reducer';
import { getInitialProductTypesState, productTypesReducer } from '@/redux/productTypes/reducer';
import { userDraftsReducer } from '@/redux/userDrafts/reducer';
import { StoreState } from './types';

export { getInitialDraft } from './getInitialDraft';

enableMapSet();

export const reducer = combineReducers<StoreState>({
  core: coreReducer,
  basket: basketReducer,
  discounts: discountsReducer,
  productTypes: productTypesReducer,
  draft: draftReducer,
  draftDispatch,
  masks: masksReducer,
  designs: designsReducer,
  modal: modalReducer as Reducer,
  userDrafts: userDraftsReducer,
});

export const init = (params: DesignerParams): Store<StoreState, AnyAction> => {
  const middlewares = [thunk, reduxActionLogMiddleware()];
  if (process.env.NODE_ENV === 'development') {
    middlewares.push(
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      require('redux-logger').createLogger({
        collapsed: () => true,
        // diff: () => true,
      })
    );
  }

  const initialState: Partial<StoreState> = {
    core: getInitialCoreState(params),
    productTypes: getInitialProductTypesState(params),
    basket: getInitialBasketState(params),
    designs: getInitialDesignState(),
  };

  // @ts-ignore
  return createStore(reducer, initialState, applyMiddleware(...middlewares));
};
